import React from 'react';
import { Typography } from '@fiverr-private/typography';
import { useLightboxContext } from '../LightboxContext';
import { LightboxLabelProps } from '../types';

import { labelStyles } from './styles.ve.css';

const LightboxLabel = ({ dataTestId }: LightboxLabelProps) => {
  const { selectedSourceIndex, maxSourceIndex, sources } = useLightboxContext();

  if (sources.length <= 1) {
    return null;
  }

  return (
    <Typography
      data-testid={dataTestId}
      position="fixed"
      color="white"
      userSelect="none"
      transform="translate(-50%, 0)"
      height="fit-content"
      className={labelStyles}
    >
      {`${selectedSourceIndex + 1} / ${maxSourceIndex + 1}`}
    </Typography>
  );
};

LightboxLabel.displayName = 'LightboxLabel';

export default LightboxLabel;
